import versions from './versions'

class MonitoringDecorator {
  wrapped = {}

  get path () { return this.wrapped.path }

  setDecorator (version) {
    this.wrapped = versions[version]
  }

  showLog (id, date, flow, processType) {
    this.wrapped.showLog(id, date, flow, processType)
  }

  showLastLogs (integrationName, processType) {
    this.wrapped.showLastLogs(integrationName, processType)
  }
}

export default new MonitoringDecorator()
